import { render, staticRenderFns } from "./GoodItem.vue?vue&type=template&id=59a14968&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=js"
export * from "./GoodItem.vue?vue&type=script&lang=js"
import style0 from "./GoodItem.vue?vue&type=style&index=0&id=59a14968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a14968",
  null
  
)

export default component.exports